import { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';

import FilterListIcon from '@mui/icons-material/FilterList';

import Loading from '../../common/Loading';
import SuppliersFilterStatus from './SuppliersFilterStatus';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function SuppliersFilter(props){
    //console.debug("RTS Break SuppliersFilter");

    const {setCurFilter, user, sessionCustomer} = useSessionContext();

    const [isLoading, setIsLoading] = useState(true);
    const [formDirty, setFormDirty] = useState(0); 

    const [status, setStatus] = useState();
    

    useEffect(() => {
        setStatus(props.filter.status);
        setIsLoading(false);
    },[props.filter.status]);
    

    function setFilter(){
        setFormDirty(0);
        setCurFilter({key:'SuppliersPage', filter:{user:user, customer:sessionCustomer.customer, status:status}});
        props.setFilterFx({user:user, customer:sessionCustomer.customer, status:status});
    }


    if(isLoading){
        return(
            <Loading />
        );
    }


    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={4} sx={{textAlign:{xs:'center',sm:'left'}}}>
                <SuppliersFilterStatus status={status} setStatusFx={setStatus} setFormDirtyFx={setFormDirty} />
            </Grid>
            <Grid item xs={12} sm={4} sx={{textAlign:{xs:'center', sm:'left'}}}>
                <Button type="button" variant="contained" disabled={formDirty===1?false:true} onClick={setFilter}>
                    <FilterListIcon />
                    <Typography sx={{ml:1}}>Filter</Typography>
                </Button>
            </Grid>            
        </Grid>
    );
}
